<ul class="c-color-picker__list">
    <li class="c-color-picker__list-item" *ngFor="let color of colors">
        <a
            class="c-color-picker__color c-color-picker__color--{{color.toLowerCase()}}"
            [ngClass]="{'c-color-picker__color--picked': picked === color}"
            (click)="pick(color)"
        ></a>
    </li>
</ul>
